import { combineReducers } from 'redux-immutable'

import data from './data'
import timelines from './timelines'
import ui from './ui'
import dialogs from './dialogs'
import feeds from './feeds'
import groups from './groups'
import assignSavedSearchesToGroup from './assign_saved_searches_to_group'

export default combineReducers({
  assignSavedSearchesToGroup,
  data,
  dialogs,
  feeds,
  groups,
  timelines,
  ui
})
